<template>
  <div class="showImgList">
    <div class="btns">
      <van-button type="default" size="small" @click="clear">取消</van-button>
      <van-button type="info" size="small" @click="clear">确定</van-button>
    </div>
    <div class="materiallist" id="materiallist">
      <div class="unify">
        <span>统一切换时间</span>
        <div>
          <van-stepper :disabled="!checked" v-model="unifyTime" @change="unify"/>
        </div>
        <div>
          <van-switch inactive-color="#ee0a24" v-model="checked" size="24px"/>
        </div>
      </div>
      <div class="materia-item" v-for="(item,index) in lists" :key="index">
        <div class="dele" :style="{
				width:height + 'px',
				height:height + 'px',
			}">
          <i class="etv etvicon etv-shanchu" @click="dele(index)"></i>
        </div>
        <img :src="upFileUrl + item.url" class="image" :style="{
				width:height + 'px',
				height:height + 'px',
			}">
        <div style="display: flex;flex-direction: column;justify-content: space-evenly" :style="{
				height:height + 'px',
			}">
          <div>切换时间(s)</div>
          <van-stepper v-model="item.playParam"/>
        </div>
        <div style="display: flex;flex-direction: column;justify-content: space-evenly" :style="{
				height:height + 'px',
			}">
          <div>切换效果</div>
          <div>
            {{exerciseTypes[parseInt(componentsList[controlIndex].mpList[0].cartoon) -1 ].name}}
          </div>
        </div>
      </div>
      <div class="photo" :style="{
							height:height + 'px',
							width: height + 'px'
						}">
        <div class="updata-centnt" @click="showAddImg">
          <div class="updata">
            <div class="updata-img">
              <img src="/static/images/updata.png" style="width: 100%;height: 100%;">
            </div>
          </div>
        </div>
      </div>
    </div>
    <addImages v-if="isImg" @setImages="getImages" @close="close"></addImages>
  </div>
</template>

<script>
  import addImages from './addImages'
  import {mapActions, mapState} from 'vuex'

  export default {
    name: 'showImgList',
    props: {
      lists: {
        type: Array,
        default: () => {
          return []
        }
      },
    },
    data() {
      return {
        height: 0,
        isImg: false,
        unifyTime: 10,
        checked: false,
        exerciseTypes: [
          {
            'id': '1',
            'name': '默认效果',
          },
          {
            'id': '2',
            'name': '右到左',
          },
          {
            'id': '3',
            'name': '左到右',
          },
          {
            'id': '4',
            'name': '上到下',
          },
          {
            'id': '5',
            'name': '下到上',
          },
          {
            'id': '6',
            'name': '手风琴挤压',
          },
          {
            'id': '7',
            'name': '放大渐变',
          },
          {
            'id': '8',
            'name': '缩小渐变',
          },
          {
            'id': '9',
            'name': '3D旋转进',
          },
          {
            'id': '10',
            'name': '3D旋转出',
          },
          {
            'id': '11',
            'name': '景深渐变',
          },
          {
            'id': '12',
            'name': '左右旋转',
          },
          {
            'id': '13',
            'name': '上下旋转',
          },
          {
            'id': '14',
            'name': '逆时针旋转',
          },
          {
            'id': '15',
            'name': '顺时针旋转',
          },
          {
            'id': '16',
            'name': '上下缩放',
          },
          {
            'id': '17',
            'name': '3D画框效果',
          },
          {
            'id': '18',
            'name': '缩放渐变',
          }, {
            'id': '19',
            'name': '放大消隐动画',
          }, {
            'id': '20',
            'name': '透明渐变',
          }, {
            'id': '21',
            'name': '渐变缩放',
          },
        ],
      }
    },

    mounted() {
      this.$nextTick(() => {
        this.height = document.getElementById('materiallist').clientWidth / 4 - 1
      })
    },
    methods: {
      ...mapActions(['addImages']),
      dele(index) {
        this.$emit('ondele', index)
      },
      showAddImg() {
        this.isImg = true
      },
      getImages(data) {
        this.addImages(data)
        this.isImg = false
      },
      close() {
        this.isImg = false
      },
      clear() {
        this.$emit('clear')
      },
      unify(val) {
        this.componentsList[this.controlIndex].mpList.map(res => {
          res.playParam = val
        })
      }

    },
    components: {
      addImages,
    },
    computed: {
      ...mapState({
        controlIndex: state => state.controlIndex,
        componentsList: state => state.componentsList,
      }),
    },
  }
</script>

<style scoped lang="scss">
  @import "../../public/static/css/app";

  .showImgList {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 55;
    background: #f1f1f1;

    .btns {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 10px;
      border-bottom: 1px solid $uni-border-bottom-color;
    }

    .materiallist {
      width: 100%;
      padding: 2px;
      box-sizing: border-box;
      position: absolute;
      overflow: auto;
      top: 46px;
      left: 0;
      bottom: 0;
      height: calc(100% - 46px);

      .unify {
        display: flex;
        padding: 5px;
        justify-content: space-between;
        background: #ffffff;
        margin: 5px;

        & > span {

        }
      }

      .photo {
        box-sizing: border-box;
        padding: 5px;

        .updata-centnt {
          width: 100%;
          height: 100%;
          border-radius: 5px;

          .updata {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            background: #ffffff;

            .updata-img {
              width: 40%;
              height: 40%;
              margin-bottom: 10px;
            }
          }
        }

      }

      .materia-item {
        position: relative;
        margin: 5px;
        box-sizing: border-box;
        display: flex;
        align-items: flex-end;
        background: #FFFFFF;
        display: flex;
        justify-content: space-between;
        padding-right: 10px;

        .dele {
          position: absolute;
          top: 2px;
          bottom: 2px;
          left: 2px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: $uni-text-color-inverse;

          .etv-shanchu {
            font-size: 35px;
          }
        }

        .image {
          height: 100%;
        }
      }
    }

  }
</style>
